import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-60c3cca1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "hue" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "hue-picker" }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]

import { computed, onUnmounted, PropType, ref, watch } from 'vue'
import tinycolor, { ColorFormats } from 'tinycolor2'


export default /*#__PURE__*/_defineComponent({
  __name: 'Hue',
  props: {
  value: {
    type: Object as PropType<ColorFormats.RGBA>,
    required: true,
  },
  hue: {
    type: Number,
    required: true,
  },
},
  emits: ["colorChange"],
  setup(__props, { emit }: { emit: ({
  (event: 'colorChange', payload: ColorFormats.HSLA): void
}), expose: any, slots: any, attrs: any }) {

const props = __props





const oldHue = ref(0)
const pullDirection = ref('')

const color = computed(() => {
  const hsla = tinycolor(props.value).toHsl()
  if (props.hue !== -1) hsla.h = props.hue
  return hsla
})

const pointerLeft = computed(() => {
  if (color.value.h === 0 && pullDirection.value === 'right') return '100%'
  return color.value.h * 100 / 360 + '%'
})

watch(() => props.value, () => {
  const hsla = tinycolor(props.value).toHsl()
  const h = hsla.s === 0 ? props.hue : hsla.h
  if (h !== 0 && h - oldHue.value > 0) pullDirection.value = 'right'
  if (h !== 0 && h - oldHue.value < 0) pullDirection.value = 'left'
  oldHue.value = h
})

const hueRef = ref<HTMLElement>()
const handleChange = (e: MouseEvent) => {
  e.preventDefault()
  if (!hueRef.value) return

  const containerWidth = hueRef.value.clientWidth
  const xOffset = hueRef.value.getBoundingClientRect().left + window.pageXOffset
  const left = e.pageX - xOffset
  let h, percent
  
  if (left < 0) h = 0
  else if (left > containerWidth) h = 360
  else {
    percent = left * 100 / containerWidth
    h = 360 * percent / 100
  }
  if (props.hue === -1 || color.value.h !== h) {
    emit('colorChange', {
      h,
      l: color.value.l,
      s: color.value.s,
      a: color.value.a,
    })
  }
}

const unbindEventListeners = () => {
  window.removeEventListener('mousemove', handleChange)
  window.removeEventListener('mouseup', unbindEventListeners)
}
const handleMouseDown = (e: MouseEvent) => {
  handleChange(e)
  window.addEventListener('mousemove', handleChange)
  window.addEventListener('mouseup', unbindEventListeners)
}
onUnmounted(unbindEventListeners)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "hue-container",
      ref_key: "hueRef",
      ref: hueRef,
      onMousedown: _cache[0] || (_cache[0] = $event => handleMouseDown($event))
    }, [
      _createElementVNode("div", {
        class: "hue-pointer",
        style: _normalizeStyle({ left: _unref(pointerLeft) })
      }, _hoisted_3, 4)
    ], 544)
  ]))
}
}

})